var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed } from 'mobx';
import Model from './Model';
import LabelModel from './LabelModel';
import Battery from '../data/BatteryStatus';
import ActivityStatus from '../data/ActivityStatus';
import LocationStatus from "../data/LocationStatus";
import Color from 'color';
import { max } from "lodash";
import DeviceModel from './DeviceModel';
/**
 *
 */
var AssetModel = /** @class */ (function (_super) {
    __extends(AssetModel, _super);
    /**
     *
     * @param data
     */
    function AssetModel(data) {
        return _super.call(this, data) || this;
    }
    /**
     *
     * @param data
     */
    AssetModel.prototype.initialize = function (data) {
        var _this = this;
        this.properties = data.properties;
        this.geometry = data.geometry;
        this.serviceEntries = [];
        this.devices = this.properties.devices.map(function (device) { return new DeviceModel(device); });
        //
        this.id = data.properties.displayedId;
        this._locationDate = new Date(data.properties.locationDateTimeUtc);
        this._accurateLocationDate = new Date(data.properties.accurateLocationDateTimeUtc);
        this._lastConnectedDateTimeUtc =
            data.properties.lastConnectedDateTimeUtc ? new Date(data.properties.lastConnectedDateTimeUtc) :
                this.getLastSampleDate();
        // this._googleMapsUrl = 'http://www.google.com/maps/place/' + this.geometry.coordinates.reverse().join(',');
        this._googleMapsUrl = this.geometry ? 'https://www.google.com/maps/search/?api=1&query=' + this.geometry.coordinates[1] + ',' + this.geometry.coordinates[0] : null;
        this.properties.locationDate = this.isManualAsset ? this._locationDate : this._accurateLocationDate;
        this.properties.googleMapsUrl = this._googleMapsUrl;
        // Add data to properties, used in map views
        this.properties.locationStatus = this.locationStatus;
        this.properties.activityStatus = this.activityStatus;
        // Search query
        var keys = Object.keys(this.properties);
        // Attributes
        keys.map(function (key) {
            switch (key) {
                case 'labels':
                    // Parse labels
                    _this.labels = _this.properties[key].map(function (data) {
                        _this._filterString += data.labelName + '\n';
                        return new LabelModel(data);
                    });
                    break;
                case 'place':
                case 'equipmentId':
                case 'alias':
                case 'model':
                case 'make':
                case 'serialNumber':
                    _this._filterString += _this.properties[key] + '\n';
                    break;
                default:
                // Do nothing
            }
        });
        //
        this._filterString = this._filterString.toLowerCase();
        this.properties.alias = "alias";
        this.iconColor = new Color(this.properties.iconColorRgba);
        this.iconColorRgba = this.iconColor.rgbNumber();
        this.iconName = this.properties.iconName;
    };
    /**
     *
     * @param data
    */
    AssetModel.prototype.update = function (data) {
        _super.prototype.update.call(this, data);
        // Add data to properties, used in map views
        this.properties.locationStatus = this.locationStatus;
        this.properties.activityStatus = this.activityStatus;
    };
    /**
     * AssetId == SerialNumber here!
     * @return {*}
     */
    AssetModel.prototype.getAssetSerial = function () {
        return this.properties.serialNumber;
    };
    /**
     *
     */
    AssetModel.prototype.getMetricsDbId = function () {
        return this.properties.assetMetricsDbId;
    };
    AssetModel.prototype.getLastSampleDate = function () {
        var dates = [];
        if (this.properties.locationDateTimeUtc) {
            dates.push(new Date(this.properties.locationDateTimeUtc));
        }
        if (this.properties.accurateLocationDateTimeUtc) {
            dates.push(new Date(this.properties.accurateLocationDateTimeUtc));
        }
        if (this.properties.cumulativeOperatingHoursDateTimeUtc) {
            dates.push(new Date(this.properties.cumulativeOperatingHoursDateTimeUtc));
        }
        if (this.properties.fuelUsedDateTimeUtc) {
            dates.push(new Date(this.properties.fuelUsedDateTimeUtc));
        }
        if (dates.length < 1) {
            return null;
        }
        return max(dates);
    };
    Object.defineProperty(AssetModel.prototype, "feedSource", {
        get: function () {
            return this.properties.feedSource;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "place", {
        get: function () {
            return (this.properties.place === "" || this.properties.place === null) ? (this.geometry.coordinates[1] + ', ' + this.geometry.coordinates[0]) : this.properties.place;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "locationLinkQuality", {
        get: function () {
            return this.properties.locationLinkQuality;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "locationDateTime", {
        get: function () {
            var _a;
            //for now always show latest accurate position if possible with fallback to any location. When changed, change the 'place' fields as well.
            return (_a = this._accurateLocationDate) !== null && _a !== void 0 ? _a : this._locationDate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "lastConnectedDateTime", {
        get: function () {
            return !this._lastConnectedDateTimeUtc ? this.latestDatetime : this._lastConnectedDateTimeUtc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "latestDatetime", {
        get: function () {
            var arr = [this.locationDateTime, this.cumulativeOperatingHoursDateTime, this.fuelUsedDateTime];
            // @ts-ignore
            return new Date(Math.max.apply(Math, arr));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "cumulativeOperatingHoursDurationInHours", {
        get: function () {
            return this.properties.cumulativeOperatingHoursDurationInHours;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "cumulativeOperatingHoursDateTimeUtc", {
        get: function () {
            return this.properties.cumulativeOperatingHoursDateTimeUtc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "cumulativeOperatingHoursDateTime", {
        get: function () {
            return this.properties.cumulativeOperatingHoursDateTimeUtc ? new Date(this.properties.cumulativeOperatingHoursDateTimeUtc) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "batteryPowerRemainingFourBarsDateTimeUtc", {
        get: function () {
            return this.properties.batteryPowerRemainingFourBarsDateTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "fuelUsedInLiters", {
        get: function () {
            return this.properties.fuelUsedInLiters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "fuelUsedDateTimeUtc", {
        get: function () {
            return this.properties.fuelUsedDateTimeUtc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "fuelUsedDateTime", {
        get: function () {
            return this.properties.fuelUsedDateTimeUtc ? new Date(this.properties.fuelUsedDateTimeUtc) : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "mainTemperatureCelsius", {
        get: function () {
            return this.properties.mainTemperatureCelsius;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "locationStatus", {
        get: function () {
            if (!this.properties.locationDate) {
                return LocationStatus.NONE;
            }
            // Activity logic
            var dt = Date.now() - this.properties.locationDate.getTime();
            if (dt <= 3600000 * 24 * 4) { // 4 days
                return LocationStatus.RECENT;
            }
            else if (dt <= 3600000 * 24 * 8) { // 8 days
                return LocationStatus.EXPIRED;
            }
            return LocationStatus.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "activityStatus", {
        get: function () {
            // Activity logic
            var dt = Date.now() - this.lastConnectedDateTime.getTime();
            if (dt <= 3600000 * 24 * 4) { // 4 days
                return ActivityStatus.RECENT;
            }
            else if (dt <= 3600000 * 24 * 8) { // 8 days
                return ActivityStatus.EXPIRED;
            }
            return ActivityStatus.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "batteryStatus", {
        get: function () {
            var devicesBatteryStatus = this.devicesBatteryStatus;
            // If there is gen2 sensors attached the asset will not have its own battery status
            if (devicesBatteryStatus.length > 0) {
                return devicesBatteryStatus;
            }
            else {
                return [this.assetBatteryStatus];
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "batteryRemainingPct", {
        get: function () {
            if (this.devices.length > 0) {
                return max(this.devices.map(function (d) { return d.batteryRemainingPctValue; }));
            }
            return -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "assetBatteryStatus", {
        get: function () {
            // AssetBatteryStatus logic
            if (this.hasLatestBatteryFourSample) {
                if (this.properties.batteryPowerRemainingFourBars === 1) {
                    return Battery.LOW;
                }
                if (this.properties.batteryPowerRemainingFourBars === 2) {
                    return Battery.MEDIUM;
                }
                if (this.properties.batteryPowerRemainingFourBars === 3) {
                    return Battery.HIGH;
                }
                return Battery.FULL;
            }
            return Battery.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "devicesBatteryStatus", {
        get: function () {
            if (this.devices.length > 0) {
                return this.devices.map(function (d) {
                    var batteryPct = d.batteryRemainingPctValue;
                    if (!batteryPct) {
                        return Battery.NONE;
                    }
                    switch (true) {
                        case (batteryPct < 0):
                            // Invalid sample
                            return Battery.NONE;
                        case (batteryPct <= 25):
                            return Battery.LOW;
                        case (batteryPct <= 50):
                            return Battery.MEDIUM;
                        case (batteryPct <= 75):
                            return Battery.HIGH;
                        case (batteryPct <= 100):
                            return Battery.FULL;
                        default:
                            return Battery.NONE;
                    }
                });
            }
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "googleMapsUrl", {
        get: function () {
            return this._googleMapsUrl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "filterString", {
        /**
         *
         * @return {string}
         */
        get: function () {
            return this._filterString;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "labelFilterArray", {
        /**
         *
         * @return {*[]}
         */
        get: function () {
            return this.labels.map(function (label) {
                return label.name;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "labelSortString", {
        get: function () {
            return this.labelFilterArray.sort().join(' ');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "hasAdditionalData", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return !!this.locationLinkQuality || !!this.cumulativeOperatingHoursDurationInHours || !!this.fuelUsedInLiters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "isManualAssetWithAttachedDevice", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.properties.assetCreationType === 'ManualWithAttachedDevice';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "isManualAsset", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.properties.assetCreationType === 'Manual';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "hasLocation", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return !(this.geometry.coordinates[0] === 0 && this.geometry.coordinates[1] === 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "hasOperatingHours", {
        get: function () {
            return this.properties.cumulativeOperatingHoursDurationInHours !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "hasLatestBatteryFourSample", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.properties.batteryPowerRemainingFourBars !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "hasFirmwareVersion", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this.properties.feedSource.firmwareVersion !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetModel.prototype, "hasLastConnectedTimeStamp", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this._lastConnectedDateTimeUtc !== null;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], AssetModel.prototype, "id", void 0);
    __decorate([
        observable
    ], AssetModel.prototype, "isArchived", void 0);
    __decorate([
        observable
    ], AssetModel.prototype, "geometry", void 0);
    __decorate([
        observable
    ], AssetModel.prototype, "properties", void 0);
    __decorate([
        observable
    ], AssetModel.prototype, "labels", void 0);
    __decorate([
        observable
    ], AssetModel.prototype, "serviceEntries", void 0);
    __decorate([
        observable
    ], AssetModel.prototype, "devices", void 0);
    __decorate([
        computed
    ], AssetModel.prototype, "locationStatus", null);
    __decorate([
        computed
    ], AssetModel.prototype, "activityStatus", null);
    __decorate([
        computed
    ], AssetModel.prototype, "batteryStatus", null);
    __decorate([
        computed
    ], AssetModel.prototype, "batteryRemainingPct", null);
    __decorate([
        computed
    ], AssetModel.prototype, "assetBatteryStatus", null);
    __decorate([
        computed
    ], AssetModel.prototype, "devicesBatteryStatus", null);
    return AssetModel;
}(Model));
export default AssetModel;
